/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

const Sticky = ({ shadow, bgColor, zIndex, position = 'sticky', ...props }) => {
  const style = css`
    position: ${position};
    top: 0;
    background-color: ${bgColor};
    ${shadow ? `box-shadow: ${COLORS.lightShadow1};` : ''}
    z-index: ${zIndex || 0};
  `

  return <div css={style} {...props} />
}

export default Sticky
